import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { CandidateInvitation } from "../../services/organization/organizationModel";

const InvitedCandidatesTable = ({
  candidateInvitations,
}: {
  candidateInvitations: CandidateInvitation[];
}) => {
  const { t } = useTranslation(["organization"]);

  return candidateInvitations.length > 0 ? (
    <div className="ui-card pro-table">
      <table>
        <thead>
          <tr>
            <th scope="col">
              {t("organization:invited-candidates.table-headers.EMAIL")}
            </th>
            <th scope="col">
              {t("organization:invited-candidates.table-headers.SENT_DATE")}
            </th>
            <th scope="col">
              {t("organization:invited-candidates.table-headers.DEADLINE")}
            </th>
          </tr>
        </thead>
        <tbody>
          {candidateInvitations.map((candidateInvitation) => (
            <tr key={`candidate-invitation-${candidateInvitation.id}`}>
              <td
                className="--full"
                data-label={t(
                  "organization:invited-candidates.table-headers.EMAIL",
                )}
              >
                <span className="pro-who">
                  <span className="pro-av" aria-hidden="true">
                    {candidateInvitation.email.slice(0, 2)}
                  </span>
                  <b>{candidateInvitation.email}</b>
                </span>
              </td>
              <td
                data-label={t(
                  "organization:invited-candidates.table-headers.SENT_DATE",
                )}
              >
                {format(new Date(candidateInvitation.createdAt), "dd/MM/yyyy")}
              </td>
              <td
                data-label={t(
                  "organization:invited-candidates.table-headers.DEADLINE",
                )}
              >
                {candidateInvitation.deadline
                  ? format(new Date(candidateInvitation.deadline), "dd/MM/yyyy")
                  : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="ui-card pro-empty">
      <span className="pro-empty_ill">
        <span className="pro-ico --search" aria-hidden="true" />
      </span>
      <b>{t("organization:invited-candidates.NO_INVITATIONS_FOUND")}</b>
    </div>
  );
};

export default InvitedCandidatesTable;
